export default "__VITE_ASSET__93edea1e__"